import React from 'react';
import { Typography } from '@mui/material';

const InvoicesDueAlert = ({ isFromPartner, partnerEmail }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      minHeight: '40px',
    }}
  >
    <Typography
      variant="body1"
      sx={{
        fontSize: '1rem',
        fontWeight: 'bold',
        textAlign: 'center',
      }}
    >
      {isFromPartner
        ? `Your subscription is past due. Please reach out to ${partnerEmail}.`
        : 'You have an overdue invoice. Please clear the payment to continue using the platform.'}
    </Typography>
  </div>
);

export default InvoicesDueAlert;
